import { ServiceFetch } from '../service-fetch'

export default class StockIssueListModel extends ServiceFetch {
    getStockIssueListBy = (data) => this.authFetch({
        url: 'stock-issue-list/getStockIssueListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}